import {createSelector} from 'reselect';

const getVehicle = state => state.vehicle;

export const selecetvehivletype = createSelector(
  [getVehicle],
  vehicle => vehicle,
);
